var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-create main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("prepayments.view_invoice_prepayment")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _vm.userType == "super_admin"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/super-admin/dashboard",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "supplier"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/supplier/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "anchor"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/anchor/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "funder"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/funder/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _vm.userType == "super_admin"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/super-admin/invoices",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                  )
                : _vm.userType == "supplier"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/supplier/invoices" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                  )
                : _vm.userType == "anchor"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/anchor/invoices" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                  )
                : _vm.userType == "funder"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/funder/invoices" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("li", { staticClass: "breadcrumb-item" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("prepayments.view_invoice_prepayment")) +
                "\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.$route.name === "preapproved-invoice-request-view-supplier" ||
      _vm.$route.name === "preapproved-invoice-request-view-anchor" ||
      _vm.$route.name === "preapproved-invoice-request-view-funder" ||
      _vm.$route.name === "preapproved-invoice-request-view"
        ? _c("SinglePreapprovedInvoiceRow", {
            attrs: { fetchData: _vm.fetchData },
          })
        : _c("SingleInvoiceRow", { attrs: { fetchData: _vm.fetchData } }),
      _vm._v(" "),
      _c("SingleRequestRow", {
        attrs: { prepaymentRequest: _vm.prepaymentRequest },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }